export class Request {
	/**   This should correspond to the visitor id stored in the cookie for the user. */
	public visitorId?: string | null;
	/**  This should correspond to the visit id stored in the cookie for the user. */
	public visitId?: string | null;
	public baseUrl?: string;
	/** This indicates whether preview has been enabled in the admin for that widget. */
	public enablePreview?: boolean;
	/** This should correspond to the Tracking Key for your engine.   */
	public clientGuid?: string;
	/** If you are on a landing page that was set up in Hawksearch, this will be the corresponding landing page url of that page. */
	public landingPageUrl?: string;
	/**  List of recommendations guids to return. */
	public widgetUids?: WidgetUid[];
	/** All information that is passed into the HawkSearch.Context object on page should be passed in here. */
	public contextProperties?: ContextDictionary;
	/** All information that is passed into HawkSearch.Context.Custom object on the page should be passed in here. */
	public customProperties?: ContextDictionary;
	public renderHTML?: boolean;
}

export interface WidgetUid {
	widgetGuid?: string;
	uniqueId?: string;
}

export class ContextDictionary {
	add(key: string, value: unknown) {
		this[key] = value;
	}

	clear() {
		for (const key in this) {
			this.remove(key);
		}
	}

	remove(key: string) {
		if (this.hasOwnProperty(key)) {
			delete this[key];
		}
	}

	constructor(state?: Record<string, unknown>) {
		if (state === undefined) {
			return;
		}

		Object.entries(state).forEach(([key, value]) => {
			this.add(key, value);
		});
	}
}
